'use strict';

define('forum/topic/postTools', [
	'share',
	'components',
	'translator',
	'forum/topic/votes',
	'api',
	'bootbox',
	'alerts',
	'hooks',
	'helpers',
	'native',
], function (share, components, translator, votes, api, bootbox, alerts, hooks, helpers, native) {
	const PostTools = {};
	const COMMUNITY_HOST = window.location.origin;
	// (window.COMMUNITY_URL[window.config.RTE][window.config.REGION] || '');

	PostTools.init = function (tid) {
		renderMenu();

		addPostHandlers(tid);

		share.addShareHandlers(ajaxify.data.titleRaw);
	};

	function renderMenu() {
		$('[component="topic"]').on('show.bs.dropdown', '.moderator-tools', function () {
			const $this = $(this);
			const dropdownMenu = $this.find('.dropdown-menu');
			if (dropdownMenu.html()) {
				return;
			}
			const postEl = $this.parents('[data-pid]');
			const pid = postEl.attr('data-pid');

			socket.emit('posts.loadPostTools', { pid: pid }, function (err, data) {
				if (err) {
					return alerts.error(err);
				}

				app.parseAndTranslate('partials/topic/post-menu-list', data, function (html) {
					dropdownMenu.html(html);
					require(['clipboard'], function (clipboard) {
						new clipboard('[data-clipboard-text]');
					});
					hooks.fire('action:post.tools.load');
				});
			});
		});
	}

	PostTools.toggle = function (pid, isDeleted) {
		let postEl = components.get('post', 'pid', pid);
		if (!postEl.length) {
			postEl = $('[component="reply-post"][data-pid="' + pid + '"]');
		}

		postEl.find('[component="post/bookmark"]:eq(0), [component="post/reply"]:eq(0), [component="post/flag"]:eq(0), [component="topic/pin"]:eq(0), [component="topic/unpin"]:eq(0), [component="post/tools"]:eq(0)')
			.toggleClass('hidden', isDeleted);

		postEl.find('[component="post/delete"]:eq(0)').toggleClass('hidden', isDeleted).parent().attr('hidden', isDeleted ? '' : null);
		postEl.find('[component="post/restore"]:eq(0)').toggleClass('hidden', !isDeleted).parent().attr('hidden', !isDeleted ? '' : null);
		postEl.find('[component="post/purge"]:eq(0)').toggleClass('hidden', !isDeleted).parent().attr('hidden', !isDeleted ? '' : null);

		PostTools.removeMenu(postEl);
	};

	PostTools.removeMenu = function (postEl) {
		postEl.find('[component="post/tools"]:eq(0) .dropdown-menu').html('');
	};

	PostTools.updatePostCount = function (postCount) {
		// 总回复数
		const count1El = $('[component="post/comment"]');
		const count2El = $('[component="post/comment-title"]');
		count1El.attr('data-count', postCount);
		count2El.attr('data-count', postCount);
		count1El.html(helpers.formatComments(postCount, true) || 0);
		count2El.find('.comments-title-text').text(`Comments (${helpers.formatComments(postCount, true) || 0})`);
	};

	function addPostHandlers(tid) {
		const postContainer = components.get('topic');

		postContainer.on('click', '[component="post/reply"]', function () {
			onReplyClicked($(this), tid);
		});

		$('.topic').on('click', '[component="topic/reply"]', function (e) {
			e.preventDefault();
			onReplyClicked($(this), tid);
		});

		postContainer.on('click', '[component="post/bookmark"]', function () {
			return bookmarkPost($(this), getData($(this), 'data-pid'));
		});

		postContainer.on('click', '[component="post/upvote"]', function () {
			return votes.toggleVote($(this), '.upvoted', 1, 'upvote');
		});

		postContainer.on('click', '[component="post/downvote"]', function () {
			return votes.toggleVote($(this), '.downvoted', -1, 'downvote');
		});

		postContainer.on('click', '[component="post/flag"]', function () {
			const pid = getData($(this), 'data-pid');
			if (native.mock) {
				require(['flags'], function (flags) {
					flags.showFlagModal({
						type: 'post',
						id: pid,
					});
				});
			} else {
				native.openWebView({
					url: `${COMMUNITY_HOST}/complaint?pid=${pid}`,
					infuseJsBridge: true,
					navBar: {
						title: 'Complaint',
						backgroundColor: '#FFFFFF',
						backButtonColor: '#1F2429',
						titleColor: '#1F2429',
					},
					closeButton: {
						hidden: true,
					},
				});
			}
		});

		postContainer.on('click', '[component="post/already-flagged"]', function () {
			alerts.alert({
				type: 'danger',
				alert_id: 'flag',
				message: 'You have already complained about this content.',
				timeout: 3000,
			});
		});

		postContainer.on('click', '[component="post/flagUser"]', function () {
			const uid = getData($(this), 'data-uid');
			require(['flags'], function (flags) {
				flags.showFlagModal({
					type: 'user',
					id: uid,
				});
			});
		});

		postContainer.on('click', '[component="post/flagResolve"]', function () {
			const flagId = $(this).attr('data-flagId');
			require(['flags'], function (flags) {
				flags.resolve(flagId);
			});
		});

		postContainer.on('click', '[component="post/edit"]', function () {
			const btn = $(this);

			const timestamp = parseInt(getData(btn, 'data-timestamp'), 10);
			const postEditDuration = parseInt(ajaxify.data.postEditDuration, 10);

			if (checkDuration(postEditDuration, timestamp, 'post-edit-duration-expired')) {
				hooks.fire('action:composer.post.edit', {
					pid: getData(btn, 'data-pid'),
				});
			}
		});

		// if (config.enablePostHistory && ajaxify.data.privileges['posts:history']) {
		// 	postContainer.on('click', '[component="post/view-history"], [component="post/edit-indicator"]', function () {
		// 		const btn = $(this);
		// 		require(['forum/topic/diffs'], function (diffs) {
		// 			diffs.open(getData(btn, 'data-pid'));
		// 		});
		// 	});
		// }

		postContainer.on('click', '[component="post/delete"]', function () {
			togglePostDelete($(this));
		});

		function checkDuration(duration, postTimestamp, languageKey) {
			if (!ajaxify.data.privileges.isAdminOrMod && duration && Date.now() - postTimestamp > duration * 1000) {
				const numDays = Math.floor(duration / 86400);
				const numHours = Math.floor((duration % 86400) / 3600);
				const numMinutes = Math.floor(((duration % 86400) % 3600) / 60);
				const numSeconds = ((duration % 86400) % 3600) % 60;
				let msg = '[[error:' + languageKey + ', ' + duration + ']]';
				if (numDays) {
					if (numHours) {
						msg = '[[error:' + languageKey + '-days-hours, ' + numDays + ', ' + numHours + ']]';
					} else {
						msg = '[[error:' + languageKey + '-days, ' + numDays + ']]';
					}
				} else if (numHours) {
					if (numMinutes) {
						msg = '[[error:' + languageKey + '-hours-minutes, ' + numHours + ', ' + numMinutes + ']]';
					} else {
						msg = '[[error:' + languageKey + '-hours, ' + numHours + ']]';
					}
				} else if (numMinutes) {
					if (numSeconds) {
						msg = '[[error:' + languageKey + '-minutes-seconds, ' + numMinutes + ', ' + numSeconds + ']]';
					} else {
						msg = '[[error:' + languageKey + '-minutes, ' + numMinutes + ']]';
					}
				}
				alerts.error(msg);
				return false;
			}
			return true;
		}

		postContainer.on('click', '[component="post/restore"]', function () {
			togglePostDelete($(this));
		});

		postContainer.on('click', '[component="post/purge"]', function () {
			purgePost($(this));
		});

		postContainer.on('click', '[component="post/move"]', function () {
			const btn = $(this);
			require(['forum/topic/move-post'], function (movePost) {
				movePost.init(btn.parents('[data-pid]'));
			});
		});

		postContainer.on('click', '[component="post/change-owner"]', function () {
			const btn = $(this);
			require(['forum/topic/change-owner'], function (changeOwner) {
				changeOwner.init(btn.parents('[data-pid]'));
			});
		});

		postContainer.on('click', '[component="post/ban-ip"]', function () {
			const ip = $(this).attr('data-ip');
			socket.emit('blacklist.addRule', ip, function (err) {
				if (err) {
					return alerts.error(err);
				}
				alerts.success('[[admin/manage/blacklist:ban-ip]]');
			});
		});

		postContainer.on('click', '[component="post/chat"]', function () {
			openChat($(this));
		});

		postContainer.on('click', '[component="post/hide"]', function () {
			togglePostHide($(this), true);
		});

		postContainer.on('click', '[component="post/show"]', function () {
			togglePostHide($(this), false);
		});
	}

	function onReplyClicked(button, tid) {
		let username = getUserSlug(button);
		if (getData(button, 'data-uid') === '0' || !getData(button, 'data-userslug')) {
			username = '';
		}
		const toPid = button.is('[component="post/reply"]') ? getData(button, 'data-pid') : null;
		const mainPid = button.closest('[data-mainPid]').attr('data-mainPid');
		const groupPid = button.parents('[component="post"]').attr('data-pid');
		const groupIndex = button.parents('[component="post"]').attr('data-index');
		const topicName = toPid === mainPid ? 'Content' : username;
		if (!native.mock) {
			native.openWebView({
				url: `${COMMUNITY_HOST}/compose?tid=${tid}&pid=${toPid}&groupPid=${groupPid}&groupIndex=${groupIndex}&topicName=${encodeURIComponent(topicName)}`,
				newWebViewCanBack: true,
				infuseJsBridge: true,
				navBar: {
					title: `Replying to ${topicName}`,
					backgroundColor: '#FFFFFF',
					backButtonColor: '#1F2429',
					titleColor: '#1F2429',
				},
				closeButton: {
					hidden: true,
				},
			});
			return;
		}

		hooks.fire('action:composer.post.new', {
			tid: tid,
			pid: toPid,
			groupPid: groupPid,
			groupIndex: groupIndex,
			topicName,
		});
	}

	function bookmarkPost(button, pid) {
		const method = button.attr('data-bookmarked') === 'false' ? 'put' : 'del';

		api[method](`/posts/${pid}/bookmark`, undefined, function (err) {
			if (err) {
				return alerts.error(err);
			}
			const type = method === 'put' ? 'bookmark' : 'unbookmark';
			hooks.fire(`action:post.${type}`, { pid: pid });

			if (type === 'bookmark' && window.tracer) {
				const post = button.closest('[component="post"]');
				const tags = [];
				post.find('.tag').each((_, e) => {
					tags.push(e.innerText.replace(/^#/, ''));
				});
				const tid = post.attr('data-tid');
				const topic = $(`[component=topic][data-tid=${tid}]`);
				window.tracer.track('SavePost', {
					post_theme: post.find('.topic-title')[0].innerText,
					tag_list: tags,
					is_text_included: !!post.find('.content')[0].innerText,
					is_vote_post: !!post.find('.ballot-list').length,
					is_image_attached: !!post.find('.ql-image').length,
					is_video_attached: !!post.find('.ql-video').length,
					poster_email: topic.attr('data-email'),
					poster_name: topic.attr('data-username'),
					poster_time: +topic.attr('data-timestamp'),
				});
			}
		});
		return false;
	}

	function getData(button, data) {
		return button.parents('[data-pid]').attr(data);
	}

	function getUserSlug(button) {
		let slug = '';
		const post = button.parents('[data-pid]');

		if (button.attr('component') === 'topic/reply') {
			return slug;
		}

		if (post.length) {
			slug = post.attr('data-username');
		}

		return slug;
	}

	function togglePostHide(button, toHide) {
		const pid = getData(button, 'data-pid');
		const ul = button.parents('ul');
		bootbox.confirm(`Are you sure to ${toHide ? 'hide' : 'show'} this comment?`, async function (confirm) {
			if (!confirm) {
				return;
			}
			ul.find('[component="post/hide"]').parent('li').toggleClass('hidden');
			ul.find('[component="post/show"]').parent('li').toggleClass('hidden');
			await api.put(`/posts/${pid}/toggleHide`).catch(alerts.error);
		});
	}

	function togglePostDelete(button) {
		const pid = getData(button, 'data-pid');
		const mainPid = button.parents('[data-mainPid]').attr('data-mainPid');
		const postEl = components.get('post', 'pid', pid);
		const action = !postEl.hasClass('deleted') ? 'delete' : 'restore';

		postAction(action, pid, mainPid);
	}

	function purgePost(button) {
		const mainPid = button.parents('[data-mainPid]').attr('data-mainPid');
		postAction('purge', getData(button, 'data-pid'), mainPid);
	}

	async function postAction(action, pid, mainPid) {
		({ action } = await hooks.fire(`static:post.${action}`, { action, pid }));
		if (!action) {
			return;
		}

		bootbox.confirm(mainPid === pid ? 'Are you sure to delete this post?' : 'Are you sure to delete this comment?', async function (confirm) {
			if (!confirm) {
				return;
			}

			const route = action === 'purge' ? '' : '/state';
			const method = action === 'restore' ? 'put' : 'del';
			await api[method](`/posts/${pid}${route}`).catch(alerts.error);
			if (mainPid === pid && !native.mock) {
				native.closeWebView();
			}
		});
	}

	function openChat(button) {
		const post = button.parents('[data-pid]');
		require(['chat'], function (chat) {
			chat.newChat(post.attr('data-uid'));
		});
		button.parents('.btn-group').find('.dropdown-toggle').click();
		return false;
	}

	return PostTools;
});
